//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from '@/utils/lodash'
import CSearch from '../CSearch'
import CSmartTags from '../CSmartTags'
import { filterByLabelFormat } from '../../utils/translate'
import CCheckCard from './CCheckCard'
import CRadioCard from './CRadioCard'

export default {
  name: 'TSelectPage',

  components: {
    CCheckCard,
    CRadioCard,
    CSearch,
    CSmartTags,
  },

  data () {
    return {
      ...this.$attrs,
      checkedValue: [],
      originalChecked: [],
      localList: [],
    }
  },

  computed: {},

  watch: {
    value: {
      handler (val, old) {
        if (val instanceof Array && this.multi) {
          this.originalChecked = cloneDeep(val) || []
          this.checkedValue = cloneDeep(this.originalChecked)
        }
      },
      deep: true,
      immediate: true,
    },

    // options: {
    //   handler (val, old) {
    //     // if (!isEqual(val, old) && val && old) {
    //     this.onChangeOptions(val || [])

    //     // }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },

  methods: {
    onListChange (list) {
      this.localList = list

      return this.localList
    },

    reload () {
      this.$refs.cSearch._load()
    },

    multiConfirmChecked () {
      if (this.beforeConfirm && !this.beforeConfirm(this.checkedValue)) {
        return
      }

      this.options = this.localList.filter((el) => this.checkedValue.indexOf(el[this.valueName]) >= 0).map((el) => {
        return {
          [this.valueName]: el[this.valueName],
          text: filterByLabelFormat(el, this.labelFormat),
        }
      }) || []

      this.originalChecked = cloneDeep(this.checkedValue)

      this.onChangeOptions(this.options || [])

      return this.onChangeValue(this.originalChecked)
    },

    onChangeOptions (val) {
      this.$emit('on-change-options', val)
    },

    onChangeValue (val) {
      this.doReturn(val)

      this.$emit('input', val)
    },

    async doReturn (val) {
      this.$emit('on-return')
    },

    clearSelect () {
      this.checkedValue = []
    },

    onSelectDataByOtherPage (options) {
      const { value, label, data } = options
      this.localList = data

      if (this.multi) {

      } else {
        if (this.beforeConfirm && !this.beforeConfirm(value)) {
          return
        }

        this.options = [
          {
            [this.valueName]: value,
            text: label,
          },
        ]

        this.onChangeOptions(this.options || [])
        this.onChangeValue(value)
      }
    },
  },
}
